import React from 'react'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardFooter
} from 'reactstrap'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Gitlab from '../../svgs/Gitlab'
import IntegrationBadge from '../../components/IntegrationBadge'
import Menu from './Menu'

export const HeaderFooterCard = ({
  integration = null,
  onClickDelete,
  onClickEdit,
  role
}) => {
  const { t } = useTranslation(['SettingsPage', 'IntegrationBadge'])

  return (
    <Card className="integration-card-sections" style={{ width: '320px' }}>
      <CardHeader className="d-flex align-items-center bg-transparent">
        <Gitlab size={2} />
        <div className="ms-2 flex-grow-1">
          <h5 className="mb-0">{t('Integrations.sections.gitlab')}</h5>
          {integration && (
            <small className="text-muted text-truncate d-block">{integration.url}</small>
          )}
        </div>
        {role === 'admin' && integration && (
          <Menu onClickDelete={onClickDelete} onClickEdit={onClickEdit} />
        )}
      </CardHeader>
      <CardBody>
        {integration ? (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <small className="text-muted fw-bold">Token status</small>
              <IntegrationBadge state={integration.state} />
            </div>
            {integration.username && (
              <div className="d-flex justify-content-between align-items-center mt-2">
                <small className="text-muted fw-bold">Username</small>
                <span className="badge bg-light text-dark border">
                  @
                  {integration.username}
                </span>
              </div>
            )}
          </>
        ) : (
          <p className="text-muted mb-0">
            Connect your GitLab instance to import and export translations.
          </p>
        )}
      </CardBody>
      <CardFooter className="bg-transparent">
        {integration ? (
          <small className="text-muted">
            Last sync:
            {' '}
            {integration.last_synced_at
              ? new Date(integration.last_synced_at).toLocaleString()
              : 'Never'}
          </small>
        ) : (
          role === 'admin' && (
            <Button color="primary" size="sm" className="w-100">
              Configure Integration
            </Button>
          )
        )}
      </CardFooter>
    </Card>
  )
}

HeaderFooterCard.propTypes = {
  integration: PropTypes.shape({
    platform: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    url: PropTypes.string,
    username: PropTypes.string,
    last_synced_at: PropTypes.string
  }),
  onClickDelete: PropTypes.func.isRequired,
  onClickEdit: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired
}

export default HeaderFooterCard
